/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { BootstrapDialog, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';

import Iconify from '../../../../@core/theme/Iconify';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';

import { useSelector } from 'react-redux';

import { selectClient } from '../../../../store/login/loginSlice';

const addEditDeclarationHealth = (props) => {
  const [infosDoc, setInfosDoc] = useState({});
  const [infosTypesOfHiring, setInfosTypesOfHiring] = useState([]);

  const company = useSelector(selectClient);

  useEffect(() => {
    getTypesOfHiring();
    setInfosDoc(props.infosItemEdit ? props.infosItemEdit : {});
  }, [props.infosItemEdit]);

  function HandleInputChange(event) {
    setInfosDoc({ ...infosDoc, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();

    let router = infosDoc.id ? '/docs/updateDoc' : '/docs/insertDoc';

    let notification = infosDoc.id
      ? 'Documento atualizado com sucesso!'
      : 'Documento adicionado com sucesso!';

    configAxios
      .post(router, infosDoc)
      .then(() => {
        props.setOpenModal(false);
        props.functionGrid();
        setInfosDoc({});
        NotificationManager.success(notification, 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  async function getTypesOfHiring() {
    configAxios
      .get(`/config/getTypesOfHiring`)
      .then((response) => {
        setInfosTypesOfHiring(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar os tipos de contratação no momento, por favor tente novamente!',
          'Atenção'
        );
      });
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <div>
        <BootstrapDialog
          onClose={() => {
            props.setOpenModal(false);
            props.functionGrid();
          }}
          aria-labelledby="customized-dialog-title"
          fullWidth
          maxWidth={'md'}
          open={props.openModal}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={() => {
              props.setOpenModal(false);
              props.functionGrid();
              setInfosDoc({});
            }}>
            Adicionar novo documento
          </BootstrapDialogTitle>
          <form onSubmit={HandleSubmit}>
            <DialogContent dividers>
              <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
              <Grid container spacing={2} sx={{ mb: 1, mt: 1 }}>
                <Grid item xs={12} md={5}>
                  <TextField
                    name="nome"
                    fullWidth
                    label="Nome do documento"
                    variant="outlined"
                    size="small"
                    required
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={infosDoc.nome || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name="qtde"
                    fullWidth
                    label="Quantidade"
                    variant="outlined"
                    type="number"
                    size="small"
                    required
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={infosDoc.qtde || ''}
                    onChange={(event) => HandleInputChange(event)}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel
                    id="label"
                    sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.3 }}>
                    Direção *
                  </InputLabel>
                  <Select
                    name="direcao"
                    fullWidth
                    size="small"
                    required
                    value={infosDoc.direcao || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={'Empresa'}>Empresa</MenuItem>
                    <MenuItem value={'Beneficiario'}>Beneficiário</MenuItem>
                    <MenuItem value={'Responsável juridico'}>Responsável juridico</MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ mb: 1, mt: 1 }}>
                <Grid item xs={12} md={4}>
                  <InputLabel
                    id="label"
                    sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.3 }}>
                    Documento(s) obrigatório * ?
                  </InputLabel>
                  <Select
                    name="obrigatorio"
                    fullWidth
                    size="small"
                    required
                    value={infosDoc.obrigatorio || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    <MenuItem value={true}>Sim</MenuItem>
                    <MenuItem value={'false'}>Não</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12} md={4}>
                  <InputLabel id="label" sx={isMobile ? { mt: 0 } : { fontSize: '13px', mt: -2.2 }}>
                    Tipo de contratação *
                  </InputLabel>
                  <Select
                    name="tpcontrat"
                    fullWidth
                    size="small"
                    required
                    value={infosDoc.tpcontrat || ''}
                    onChange={(event) => HandleInputChange(event)}>
                    {/* <MenuItem value={'1-INDIVIDUAL/FAMILIAR'}>1-INDIVIDUAL/FAMILIAR</MenuItem>
                    <MenuItem value={'2-COLETIVO EMPRESARIAL'}>2-COLETIVO EMPRESARIAL</MenuItem>
                    <MenuItem value={'3-COLETIVO POR ADESAO'}>3-COLETIVO POR ADESÃO</MenuItem> */}
                    {infosTypesOfHiring.map((item) => (
                      <MenuItem key={item.id} value={item.tpcontrat}>
                        {item.tpcontrat}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {company === 'higiasaude' && (
                  <Grid item xs={12} md={4}>
                    <InputLabel
                      id="label"
                      sx={isMobile ? { fontSize: '13px', mt: 0 } : { fontSize: '13px', mt: -2.3 }}>
                      Formato da venda *
                    </InputLabel>
                    <Select
                      name="formato"
                      fullWidth
                      size="small"
                      required
                      value={infosDoc.formato || ''}
                      onChange={(event) => HandleInputChange(event)}>
                      <MenuItem value={'1-29'}>1 a 29 vidas</MenuItem>
                      <MenuItem value={'30-99'}>30 a 99 vidas</MenuItem>
                    </Select>
                  </Grid>
                )}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                color="success"
                variant="contained"
                type="submit"
                startIcon={<Iconify icon="eva:save-fill" />}>
                {infosDoc.id ? 'Atualizar' : 'Salvar'}
              </Button>
              <Button
                onClick={() => {
                  props.setOpenModal(false);
                  props.functionGrid();
                  setInfosDoc({});
                }}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="eva:close-circle-fill" />}>
                Cancelar
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
    </>
  );
};

export default addEditDeclarationHealth;
